import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../lib/LanguageContext';
import { translations } from '../../lib/translations';
export function MathClosureSection() {
  const titleRef = useRef<HTMLDivElement>(null);
  const titleInView = useInView(titleRef, {
    once: true,
    margin: '-80px'
  });
  const bodyRef = useRef<HTMLDivElement>(null);
  const bodyInView = useInView(bodyRef, {
    once: true,
    margin: '-60px'
  });
  const closingRef = useRef<HTMLDivElement>(null);
  const closingInView = useInView(closingRef, {
    once: true,
    margin: '-60px'
  });
  const {
    lang
  } = useLanguage();
  const t = translations[lang].mathClosure;
  return <section style={{
    width: '100%',
    backgroundColor: 'var(--black)',
    color: 'var(--white)',
    padding: '10rem 1.5rem'
  }} data-id="element-218">
      <div style={{
      maxWidth: '48rem',
      margin: '0 auto'
    }} data-id="element-219">
        {/* Section label */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: '0.65rem',
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
        color: 'var(--grey-500)',
        marginBottom: '3rem'
      }} data-id="element-220">
          {t.label}
        </motion.p>

        {/* Title */}
        <motion.div ref={titleRef} initial={{
        opacity: 0,
        y: 20
      }} animate={titleInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} style={{
        marginBottom: '6rem'
      }} data-id="element-221">
          <h2 style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: 700,
          fontSize: 'clamp(1.75rem, 4vw, 3rem)',
          color: 'var(--white)',
          lineHeight: 1.15,
          letterSpacing: '-0.01em',
          margin: 0
        }} data-id="element-222">
            {t.title1}
            <span style={{
            color: 'var(--red)'
          }} data-id="element-223">
              {t.title2}
            </span>
          </h2>
        </motion.div>

        {/* Statement lines */}
        <div ref={bodyRef} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '3rem'
      }} data-id="element-224">
          {t.statements.map((text, i) => <motion.p key={i} initial={{
          opacity: 0,
          x: -12
        }} animate={bodyInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.7,
          delay: i * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} style={{
          fontFamily: '"IBM Plex Sans", sans-serif',
          fontWeight: i >= 4 ? 400 : 300,
          fontSize: 'clamp(1rem, 2vw, 1.1875rem)',
          color: i >= 4 ? 'var(--white)' : 'rgba(255,255,255,0.55)',
          lineHeight: 1.75,
          margin: 0,
          whiteSpace: 'pre-line',
          borderLeft: i >= 4 ? '1px solid rgba(196,30,30,0.35)' : 'none',
          paddingLeft: i >= 4 ? '1.5rem' : '0'
        }} data-id="element-225">
              {text}
            </motion.p>)}
        </div>

        {/* Divider */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} whileInView={{
        opacity: 1,
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} style={{
        height: '1px',
        backgroundColor: 'rgba(255,255,255,0.08)',
        margin: '5rem 0',
        transformOrigin: 'left'
      }} data-id="element-226" />

        {/* Closing statement */}
        <motion.div ref={closingRef} initial={{
        opacity: 0,
        y: 16
      }} animate={closingInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-227">
          <p style={{
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: '0.75rem',
          letterSpacing: '0.25em',
          textTransform: 'uppercase',
          color: 'var(--red)',
          lineHeight: 1.6
        }} data-id="element-228">
            {t.closing}
          </p>
        </motion.div>
      </div>
    </section>;
}